import { RolePermissionVldDto } from './RolePermissionVld.model';

export enum RoleVld {
  DivisionAdministrator = 1,
  DepartmentCountEditor = 2,
  DepartmentCountReader = 3,
  DivisionReader = 4,
  SubmissionDivisionAdministrator = 5,
  SubmissionEditor = 6,
  SubmissionReader = 7,
}


export class RoleVldDto {
  public static readonly Type = RoleVld;

  public roleVldID: number;
  public roleName: string;
  public applicationVldID: number;

  public rolePermissionVlds: RolePermissionVldDto[];
}
